__turbopack_context__.v({
  "accordion": "BlockMediaAccordion-module-scss-module__Ew0eMq__accordion",
  "flushBottom": "BlockMediaAccordion-module-scss-module__Ew0eMq__flushBottom",
  "flushTop": "BlockMediaAccordion-module-scss-module__Ew0eMq__flushTop",
  "inner": "BlockMediaAccordion-module-scss-module__Ew0eMq__inner",
  "media": "BlockMediaAccordion-module-scss-module__Ew0eMq__media",
  "mediaOnLeft": "BlockMediaAccordion-module-scss-module__Ew0eMq__mediaOnLeft",
  "root": "BlockMediaAccordion-module-scss-module__Ew0eMq__root",
});
